import React, { Component } from 'react';
import GroupsManager from './GroupsManager';
import Validators from '../../../../common/utils/Validators';
import { getGroupsByRegion } from '../RegionsManager/RegionsManager.actions';
import { saveGroup, deleteGroup } from './GroupManager.actions.js';
import Store from '../../../../redux/Store';
import { showSnackbar } from '../../../../common/state/snackbar/Snackbar.actions';
import Constants from '../../../../common/constants/Constants';
import { withRouter } from '../../../../common/utils/NavigationWrapper';
import Loading from '../../../../common/components/Loading/Loading';

class GroupsManagerContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      groupToBeAdded: {},
      showDialog: { show: false, title: '', action: () => {}, cancel: () => {} },
      errorMessageGroupName: '',
      errorMessageNewGroupName: '',
      isFetching: false,
      showConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
        disableMainAction: false,
      },
      messageToConfirm: '',
      groups: props.groups,
      isSaving: false,
    };
  }

  componentDidMount() {
    const { params } = this.props;
    let groups = null;
    let groupId = parseInt(params.id, 10);

    //reaload resources if navigation via browser link happens
    if (params.id && this.props.groups.length === 0) {
      this.setState({ isFetching: true });
      getGroupsByRegion(groupId)
        .then((res) => {
          groups = res.body;
          this.setState({
            groups,
            isFetching: false,
          });
        })
        .catch((err) => {
          this._showFailMessage('Error occured while loading groups.');
        });
    }
  }

  render() {
    return (
      <Loading condition={this.state.isFetching}>
        <GroupsManager
          groupTileTitle={`Groups of region "${this.props.region.Name}"`}
          tileTitle={`Region "${this.props.region.Name}"`}
          onAddGroup={this._openAddGroupDialogCallback}
          data={this.state.groups}
          onDeleteCallback={this._onDeleteGroup}
          onEditCallback={this._onEditGroup}
          showConfirmDialog={this.state.showConfirmDialog}
          messageToConfirm={this.state.messageToConfirm}
          showDialog={this.state.showDialog}
          onChangeCallback={this._onChangeNewGroup}
          errorGroupName={this.state.errorMessageNewGroupName}
          isSaving={this.state.isSaving}
          groupName={this.state.groupToBeAdded ? this.state.groupToBeAdded.Name : ''}
          region={this.props.region}
        />
      </Loading>
    );
  }

  _openAddGroupDialogCallback = () => {
    this.setState({
      showDialog: {
        show: true,
        title: 'Add new group',
        action: this._addGroup, //TODO create group function
        cancel: this._cancelCreatingGroup,
      },
    });
  };

  _addGroup = () => {
    if (
      this.state.groupToBeAdded.Name &&
      !this._existingGroupValidation(this.state.groupToBeAdded.Name)
    ) {
      this.setState({ isSaving: true });

      let newGroup = {
        ...Object.assign({}, this.state.groupToBeAdded),
        RegionId: this.props.region.RegionId,
      };

      saveGroup(newGroup)
        .then(() => getGroupsByRegion(this.props.region.RegionId))
        .then((res) => {
          this.setState({
            groups: res.body,
            showDialog: { show: false, title: '', action: () => {}, cancel: () => {} },
            isSaving: false,
          });
          this._showSuccesMessage('Successfully added.');
        })
        .catch((err) => {
          this.setState({ isSaving: true });
          this._showFailMessage('Error occured');
        });
    } else {
      this._showFailMessage('Empty group name or similar group name already exists!');
    }
  };

  _cancelCreatingGroup = () => {
    this.setState({
      showDialog: { show: false, action: () => {}, cancel: () => {} },
      groupToBeAdded: {},
      errorMessageNewGroupName: '',
    });
  };

  _onDeleteGroup = (groupToDelete) => {
    this.setState({
      messageToConfirm: `Are you sure you want to delete group "${groupToDelete.Name}"?`,
      showConfirmDialog: {
        title: `Delete group ${groupToDelete.Name}`,
        show: true,
        action: () => this._onConfirmDeleteGroup(groupToDelete),
        cancel: this._onCancelDeleteGroup,
        mainActionLabel: 'Yes',
      },
    });
  };

  _onConfirmDeleteGroup = (groupToDelete) => {
    if (groupToDelete) {
      this.setState({ showConfirmDialog: { disableMainAction: true } });

      deleteGroup(groupToDelete.GroupId)
        .then(() => getGroupsByRegion(this.props.region.RegionId))
        .then((resp) => {
          this.setState({
            groups: resp.body,
            messageToConfirm: '',
            showConfirmDialog: {
              show: false,
              disableMainAction: false,
            },
          });
          this._showSuccesMessage('Successfully deleted.');
        })
        .catch((err) => this._showFailMessage('Error occured'));
    }
  };

  _onCancelDeleteGroup = () => {
    this.setState({
      messageToConfirm: '',
      showConfirmDialog: {
        show: false,
      },
    });
  };

  _onEditGroup = (groupToEdit) => {
    const { navigate } = this.props;
    navigate(`/group-details/${groupToEdit.GroupId}`);
  };

  _onChangeNewGroup = (propertyName, value) => {
    let group = {
      ...Object.assign({}, this.state.groupToBeAdded),
      [propertyName]: value,
    };
    this.setState((prevState) => ({
      groupToBeAdded: group,
      errorMessageNewGroupName:
        prevState.groupToBeAdded.Name !== group.Name
          ? this._getValidationErrorMessage(value)
          : prevState.errorMessageNewGroupName,
    }));
  };

  _getValidationErrorMessage = (value) => {
    let validationMessage = '';
    if (!Validators.validateStringBetweenRange(value, 1, 200)) {
      validationMessage =
        'Enter an alphanumeric value between 1 and 200 characters; for example: Group 01';
    }
    return validationMessage;
  };

  _existingGroupValidation = (value) => {
    for (let group of this.state.groups) {
      if (value.toLowerCase().replace(/\s/g, '') === group.Name.toLowerCase().replace(/\s/g, '')) {
        return true;
      }
    }
  };

  _showSuccesMessage(theMessage) {
    Store.dispatch(
      showSnackbar({
        type: Constants.SNACKBAR_MESSAGE_TYPES.SUCCESS,
        message: theMessage,
      })
    );
  }

  _showFailMessage(theMessage) {
    Store.dispatch(
      showSnackbar({
        type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
        message: theMessage,
      })
    );
  }
}

export default withRouter(GroupsManagerContainer);
